<!-- MIT License

Copyright (c) 2017 scope.wu

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE. -->

<template>
    <div class="modal">
        <div class="modal-wrapper">
            <div class="container-modal">
                <template v-if="pixCopiaECola == 'pix_vai_ser_gerado'">
                    <h1>QRCode para o pagamento do pix será gerado na data de vencimento</h1>
                </template>
                <template v-else>
                    <qrcode-vue
                        :value="pixCopiaECola"
                        size="300"></qrcode-vue>
    
                    <h1
                        class="pix-copia-e-cola">{{ pixCopiaECola }}</h1>
                </template>

                <button-default
                    style="margin-top: 20px;"
                    @click.native="$emit('fechar')"
                    text="FECHAR"></button-default>

                <button-default
                    v-if="pixCopiaECola != 'pix_vai_ser_gerado'"
                    style="margin-top: 20px;"
                    @click.native="copiarPixCopiaECola"
                    text="COPIAR"></button-default>
            </div>
        </div>
    </div>
</template>

<script>
import QrcodeVue from "qrcode.vue";

import ButtonDefault from "../../../../components/buttons/ButtonDefault.vue";

export default {
    name: "TelaQrCodePix",

    components: { ButtonDefault, QrcodeVue },

    props: {
        pixCopiaECola: {
            type: String,
            required: true
        }
    },

    methods: {
        copiarPixCopiaECola() {
            let textoPixCopiaECola = document.getElementsByClassName('pix-copia-e-cola')[0];
            navigator.clipboard.writeText(textoPixCopiaECola.innerHTML);
            alert('PIX copiado para sua área de transferência');
        }
    }
}
</script>

<style>
    .modal {
        position: fixed;
        z-index: 9999;
        background-color: rgba(0, 0, 0, 0.5);
        display: table;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .container-modal {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 500px;
        margin: 0px auto;
        background-color: #fff;
        border-radius: 10px;
        padding: 80px 80px 35px;
    }

    .pix-copia-e-cola {
        width: 300px;
        margin-top: 30px;
        border: 3px #000 solid;
        padding: 20px;
        border-radius: 10px;
        word-wrap: break-word;
    }
</style>